/*
 * Scroll infini pour les pages collection (thème Split / AMANA)
 * -------------------------------------------------------------
 * Améliore progressivement la pagination numérotée existante :
 *   - charge automatiquement la page suivante quand l'utilisateur approche du bas ;
 *   - injecte les cartes produit dans la grille existante (les Web Components
 *     quick-add / variantes / product-form se ré-initialisent seuls à l'insertion) ;
 *   - masque la pagination numérotée (conservée dans le DOM comme fallback SEO / no-JS) ;
 *   - se ré-initialise après un filtrage/tri AJAX (événement `collection:updated`
 *     émis par component-facets.js).
 *
 * Le HTML injecté provient du rendu de section same-origin de la boutique
 * (Section Rendering API), donc de confiance équivalente au rendu initial.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window) || !('fetch' in window)) return; // fallback : pagination numérotée visible

  var HOLDER_ID = 'CollectionProductGrid';           // conteneur remplacé en entier par le filtrage AJAX
  var GRID_ID = 'main-collection-product-grid';       // grille interne, porte data-id = id de section
  var LOADING_CLASS = 'is-loading-more';
  var PREFETCH_MARGIN = '800px 0px';                  // déclenche le chargement avant d'atteindre le bas

  var state = {
    loading: false,
    nextUrl: null,
    sectionId: null,
    observer: null,
    sentinel: null,
    requested: {} // urls déjà demandées (garde-fou anti-boucle)
  };

  injectStyles();

  function injectStyles() {
    if (document.getElementById('infinite-scroll-styles')) return;
    var css =
      '.infinite-scroll-hidden{display:none !important;}' +
      '.infinite-scroll-sentinel{width:100%;min-height:1px;display:flex;align-items:center;justify-content:center;padding:24px 0;grid-column:1/-1;}' +
      '.infinite-scroll-spinner{width:34px;height:34px;border:3px solid currentColor;border-top-color:transparent;border-radius:50%;opacity:.55;animation:infinite-scroll-spin .7s linear infinite;}' +
      '.infinite-scroll-sentinel[hidden]{display:none !important;}' +
      '@keyframes infinite-scroll-spin{to{transform:rotate(360deg);}}';
    var style = document.createElement('style');
    style.id = 'infinite-scroll-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function getGrid() { return document.getElementById(GRID_ID); }

  function getPagination(root) {
    return (root || document).querySelector('#' + HOLDER_ID + ' .pagination');
  }

  function getNextUrl(root) {
    var link = (root || document).querySelector('#' + HOLDER_ID + ' .pagination a.next');
    return link ? link.getAttribute('href') : null;
  }

  // Conteneur où empiler les nouvelles cartes : le dernier .product-grid-border-fix
  // contenant réellement des produits (gère aussi les collections à bannière = 2 conteneurs).
  function getAppendTarget(grid) {
    var containers = grid.querySelectorAll('.product-grid-border-fix');
    for (var i = containers.length - 1; i >= 0; i--) {
      if (containers[i].querySelector('.box__collection .product-holder')) return containers[i];
    }
    return containers.length ? containers[containers.length - 1] : grid;
  }

  // Transforme une URL de page en URL de rendu de section (léger : seule la section revient)
  function toSectionUrl(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', state.sectionId);
    return url.toString();
  }

  function teardown() {
    if (state.observer) { state.observer.disconnect(); state.observer = null; }
    if (state.sentinel && state.sentinel.parentNode) state.sentinel.parentNode.removeChild(state.sentinel);
    state.sentinel = null;
    state.nextUrl = null;
    state.loading = false;
    state.requested = {}; // repart à zéro (ex. après un changement de filtre qui remet la grille en page 1)
  }

  function init() {
    teardown();

    var grid = getGrid();
    if (!grid) return;
    state.sectionId = grid.dataset.id;
    state.nextUrl = getNextUrl();
    if (!state.nextUrl) return; // une seule page : rien à faire

    // Masque la pagination numérotée (reste dans le DOM pour SEO / no-JS)
    var pag = getPagination();
    if (pag) pag.classList.add('infinite-scroll-hidden');

    // Sentinelle + spinner juste avant la pagination (donc en fin de grille)
    var sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.innerHTML = '<div class="infinite-scroll-spinner" aria-hidden="true"></div>';
    if (pag && pag.parentNode) {
      pag.parentNode.insertBefore(sentinel, pag);
    } else {
      grid.appendChild(sentinel);
    }
    state.sentinel = sentinel;

    state.observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadNext(); break; }
      }
    }, { rootMargin: PREFETCH_MARGIN });
    state.observer.observe(sentinel);
  }

  function loadNext() {
    if (state.loading || !state.nextUrl) return;
    if (state.requested[state.nextUrl]) return; // déjà chargé : stop (garde-fou)
    state.requested[state.nextUrl] = true;
    state.loading = true;

    var grid = getGrid();
    if (grid) grid.classList.add(LOADING_CLASS);

    var url = toSectionUrl(state.nextUrl);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Récupère uniquement les cartes produit (exclut image de collection et cases vides)
        var boxes = doc.querySelectorAll('#' + HOLDER_ID + ' .box__collection');
        var chunk = '';
        for (var i = 0; i < boxes.length; i++) {
          var box = boxes[i];
          if (box.classList.contains('box__collection_image')) continue;
          if (!box.querySelector('.product-holder')) continue; // ignore les cases de remplissage
          chunk += box.outerHTML;
        }

        if (chunk) {
          // insertAdjacentHTML parse dans le document courant => les Web Components
          // (quick-add, variantes…) s'upgradent et exécutent leur connectedCallback.
          getAppendTarget(getGrid()).insertAdjacentHTML('beforeend', chunk);
        }

        // URL suivante d'après la pagination de la réponse
        state.nextUrl = getNextUrl(doc);

        state.loading = false;
        var g = getGrid();
        if (g) g.classList.remove(LOADING_CLASS);

        document.dispatchEvent(new CustomEvent('infinite-scroll:appended'));

        if (!state.nextUrl) {
          // Dernière page atteinte : on retire la sentinelle et l'observer
          if (state.observer) { state.observer.disconnect(); state.observer = null; }
          if (state.sentinel && state.sentinel.parentNode) state.sentinel.parentNode.removeChild(state.sentinel);
          state.sentinel = null;
        } else if (state.sentinel) {
          // Si la sentinelle est encore dans le viewport (page courte / grand écran), on enchaîne
          var rect = state.sentinel.getBoundingClientRect();
          if (rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 800) {
            loadNext();
          }
        }
      })
      .catch(function () {
        // En cas d'échec réseau : on rétablit la pagination numérotée pour ne pas bloquer la navigation
        state.loading = false;
        var g = getGrid();
        if (g) g.classList.remove(LOADING_CLASS);
        var pag = getPagination();
        if (pag) pag.classList.remove('infinite-scroll-hidden');
        if (state.observer) { state.observer.disconnect(); state.observer = null; }
        if (state.sentinel && state.sentinel.parentNode) state.sentinel.parentNode.removeChild(state.sentinel);
        state.sentinel = null;
      });
  }

  function boot() { init(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Ré-initialisation après filtrage / tri AJAX (grille remplacée par component-facets.js)
  document.addEventListener('collection:updated', function () { init(); });
})();
